<!-- 标题 -->
<template>
  <div class="title-container" v-if="data.que_type !== 7">
    <div class="checkbox-flag"
      ><span v-if="data.que_type == 1">（多选）</span></div
    >
    <div class="title">{{ (data && data.que_title) || '' }}</div>
    <!--  <div class="title-desc" v-if="descData.type == 'text'">{{ descData.text }}</div> -->
    <QuestionImage v-if="descData.type == 'image'" :url="descData.url" />
  </div>
</template>
<script>
import QuestionImage from './q-image.vue'
export default {
  components: {
    QuestionImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    descData() {
      this.data.que_introduce = this.data.que_introduce || ''
      if (typeof this.data.que_introduce == 'string') {
        return {
          type: 'text',
          text: this.data.que_introduce
        }
      }
      return {
        type: this.data.que_introduce.type || 'text',
        text: this.data.que_introduce.text || '',
        url: this.data.que_introduce.url || ''
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #202539;
  line-height: 34px;
  margin-bottom: 4px;
}

.checkbox-flag {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #373d52;
  line-height: 21px;
  height: 21px;
}

.title-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #27243c;
  line-height: 17px;
}
</style>
